import { createAction } from '@reduxjs/toolkit';
import { FetchTenantConfigPayload } from './tenantConfigTypes';

export const fetchTenantConfig = createAction<FetchTenantConfigPayload>(
  'TENANT_CONFIG/FETCH_CONFIG'
);
